import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { DatePicker } from '@openng/optimus-ui/datepicker';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface DatePickerProps extends FieldWrapperProps {
  defaultDate?: Date;
  minDate?: Date;
  maxDate?: Date;
  dateFormat?: string;
  hourFormat?: string;
  showTime?: boolean;
  showButtonBar?: boolean;
  showOtherMonths?: boolean;
  selectOtherMonths?: boolean;
  numberOfMonths?: number;
  selectionMode?: 'single' | 'multiple' | 'range';
  readonlyInput?: boolean;
  inline?: boolean;
  touchUI?: boolean;
  timeOnly?: boolean;
  showWeek?: boolean;
  disabledDays?: number[];
  disabledDates?: Date[];
  view?: 'date' | 'month';
  dataType?: 'date' | 'string';
}

export interface DatepickerFieldConfig extends FormlyFieldConfig<DatePickerProps> {
  type?: 'date-picker' | Type<DateTypeComponent>;
}

@Component({
  selector: 'lib-formly-date-type',
  templateUrl: './date-type.component.html',
  styleUrl: './date-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoDirective, DatePicker, ReactiveFormsModule, FormlyModule, NgClass]
})
export class DateTypeComponent extends FieldType<FieldTypeConfig<DatePickerProps>> {}
